module.exports = __webpack_public_path__ + "static/media/youtubeMusicPodcastBadge.ae813c91.png";